import React from 'react';
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';
  
const Available_Funds = ({
    auth: {
        user,
        loading
    },
    showLink
}) =>  {
	return (
	    <div className='order'>

            <div className='order__headerText'>
                <h3 className='line-clamp' style={{marginBottom: '5px', overflow:'hidden' , fontSize:'16px', fontWeight:'500', color:'#333', maxWidth:'100%'}}>
                    Available Funds
                </h3>
            </div>
            <h1 style={{fontWeight: 600}}>
                {user?.available_funds ? 
                    (user?.available_funds / 100).toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    }) : 
                    '$0.00'
                }
            </h1>
            <div className='order__headerDescription'>
                <span style={{margin: '5px 0'}}>Funds will get added when you boost a post</span>
                
                {showLink && (
                    <span onClick={() => window.location.href = '/settings/payments'} className='hover_underline' style={{margin: '5px 0', width: 'fit-content', display: 'flex', color: 'rgb(29, 155, 240)', fontWeight: 500, cursor: 'pointer', zIndex: 10}}>View Payment Activity</span>
                )}
            </div>

        </div>
	);
  }
  
Available_Funds.propTypes = {
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    auth: state.auth,
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
})(Available_Funds);
  